{
  "es": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Cambiar logotipo (PNG obligatorio)",
        "changeThemeColor": "Elige un nuevo color de tema"
      },
      "labels": {
        "customerThemeColor": "Color de tema del cliente",
        "customerThemeColorExlainer": "Este color se usará en el portal del cliente. Suplanta a un cliente para verlo en acción.",
        "logo": "Logotipo"
      },
      "picture_logo_format": {
        "round": "Logotipo redondo",
        "square": "Logotipo cuadrado"
      }
    }
  }
}
